var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdvLogoSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 38,
    viewBox: "0 0 57 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3582 9.58335L36.0434 6.86756C33.8151 5.68726 31.2414 5.01373 28.5 5.01373C28.4712 5.01373 28.4424 5.01381 28.4137 5.01396C28.2574 5.99374 28.161 6.97941 28.0818 8.14377C28.2206 8.13927 28.36 8.137 28.5 8.137C30.6298 8.137 32.6289 8.66265 34.3582 9.58335Z",
    fill: "#24A0ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8047 25.9712C13.7369 24.0077 13.1348 21.7842 13.1348 19.4288C13.1348 11.4946 19.9674 5.05751 28.4137 5.01395C28.2574 5.99373 28.161 6.97941 28.0818 8.14376C21.7057 8.35065 16.6043 13.2702 16.6043 19.3087C16.6043 21.1165 17.0616 22.8241 17.8734 24.335L14.8047 25.9712Z",
    fill: "#24A0ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8654 19.4288C43.8654 14.0395 40.7129 9.3409 36.0435 6.86758L34.3583 9.58337C37.9633 11.5027 40.3958 15.1389 40.3958 19.3087C40.3958 24.6711 36.3729 29.151 31.0068 30.2319L32.4702 33.3581C39.0319 31.7163 43.8654 26.1021 43.8654 19.4288Z",
    fill: "#24A0ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.438 5.01375L29.6152 0.0285339C32.8483 0.17217 36.0178 0.815942 39.0713 2.01145L36.0586 6.87569C33.547 5.9457 31.0581 5.01069 28.438 5.01375Z",
    fill: "#24A0ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6772 0.0285192C18.537 -0.466403 6.94661 5.46107 0 19.3205C1.96586 23.6474 3.5213 25.8154 6.87717 29.351L12.7011 26.9484C9.63679 24.1593 8.28397 22.4954 6.62935 19.3205C12.3227 9.9052 20.012 5.49423 28.438 5.01373L29.6772 0.0285192Z",
    fill: "#24A0ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0586 6.87568C41.5482 8.9083 46.8005 13.0538 50.4326 19.3205C47.1489 25.1466 42.1923 30.4922 32.2793 33.195L34.9434 38C44.8145 35.4378 52.2913 29.2308 56.9999 19.3205C53.0719 10.8747 46.5166 4.93816 39.0713 2.02322L36.0586 6.87568Z",
    fill: "#24A0ED"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5621,
    cy: 19.3087,
    rx: 8.1163,
    ry: 7.56791,
    fill: "#24A0ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5879 18.5279V22.1917C26.0751 22.7688 26.4305 22.902 27.1368 22.9725H30.1727C30.8342 22.8537 31.0946 22.6713 31.4118 22.1917V18.5279H30.8542V17.2665C29.9868 15.1643 27.2607 14.804 26.2694 17.2665V18.5279H25.5879ZM27.1988 18.3477H29.9248V17.5068C29.4292 16.2455 27.7564 16.1253 27.1988 17.5068V18.3477ZM28.314 20.7502V21.5911H28.0662V21.8313H28.9955V21.5911H28.7477V20.7502H28.9955V20.0895C28.9609 19.9511 28.9015 19.9022 28.7477 19.8493H28.314C28.1362 19.9202 28.1116 19.9796 28.0697 20.0809L28.0662 20.0895V20.7502H28.314Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdvLogoSingle);
export default __webpack_public_path__ + "static/media/MDVLogoSingle.c0265778aaeab7f513f3ada755c6fe18.svg";
export { ForwardRef as ReactComponent };